module.exports = __webpack_public_path__ + "static/media/cdg-home-img5735x635.85fe90ab.png";